const inscripcion = {
  createInscripcionManual: 'inscripcion/{{uuid_academia}}/manual',
  readInscripcionesAlumno: 'inscripciones/{{uuid_academia}}/alumno',
  readInscripcionesProyecto: 'inscripciones/{{uuid_proyecto}}',
  readInscripcionesProyectoExportar: 'inscripciones/{{uuid_proyecto}}/exportar',
  readInscripcionNodos: '{{uuid_inscripcion}}/nodos_activos',
  updateInscripcionEstado: 'inscripcion/{{uuid_academia}}/estado',
  updateInscripcionNodoEstado: 'inscripcion/{{uuid_inscripcion}}/{{uuid_nodo}}'
}

export default inscripcion
